import { Box, Stack, Typography } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { InfoIcon } from "@/assets";

export const PropertyStandardInfluenceInfo = (): JSX.Element => {
  const { t } = useTranslation("PricePositioningPanel");

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.semanticColors.surface.blueBg,
        padding: "20px",
      })}
    >
      <Stack gap="8px">
        <Stack direction="row" alignItems="center" gap="12px">
          <InfoIcon
            sx={(theme) => ({
              fontSize: "20px",
              color: theme.themeColors.schwarzgrau500,
            })}
          />
          <Typography variant="tableHeader">{t("standardImpact.title")}</Typography>
        </Stack>
        <Typography>{t("standardImpact.text")}</Typography>
      </Stack>
    </Box>
  );
};
